import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import * as sidebar from 'components/sidebar';
import { isMobile } from 'utilities/devices';

const module = angular.module('layout-with-sidebar', [sidebar.module.name]);

interface LayoutWithSidebarController extends angular.IStrictController {
    showMobileAppDownloadCard: boolean;
}

module.component('layoutWithSidebar', {
    template: template,
    bindings: {
        hideQuickLinksCard: '<',
        hidePaymentIssuesCard: '<',
        hideReactivateCard: '<',
        showMobileAppDownloadCard: '&'
    },
    transclude: true,
    controller: function(
        this: LayoutWithSidebarController,
        $window: angular.IWindowService
    ) {
        this.$onInit = () => {
            this.showMobileAppDownloadCard = isMobile();
        };
    }
});

export { module };
